import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";

export default {
  getCompetitors() {
    return apiService.get(endpoints.limits.competitors);
  },
  deleteCompetitor(id) {
    return apiService.delete(endpoints.limits.deleteCompetitor(id));
  },

  getKeywords() {
    return apiService.get(endpoints.limits.keywords);
  },
  deleteKeyword(id) {
    return apiService.delete(endpoints.limits.deleteKeyword(id));
  },

  getFacilities() {
    return apiService.get(endpoints.limits.facilities);
  },
  deleteFacility(id) {
    return apiService.delete(endpoints.limits.deleteFacility(id));
  },

  getMembers() {
    return apiService.get(endpoints.limits.members);
  },
  deleteMember(id) {
    return apiService.delete(endpoints.limits.deleteMember(id));
  },

  getTags() {
    return apiService.get(endpoints.limits.tags);
  },
  deleteTag(id) {
    return apiService.delete(endpoints.limits.deleteTag(id), {
      data: { type: "PLACE" }
    });
  }
};
